export default __webpack_public_path__ + "static/media/true-or-false-image.4b65c141.jpg";